(function () {
  var EASE = 'cubic-bezier(0.23, 1, 0.32, 1)';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var toggle = document.querySelector('.menu-toggle');
    var nav = document.getElementById('mobile-nav');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      });
    }
  }

  function initReveals() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function money(cents) {
    var root = document.documentElement;
    var format = root.getAttribute('data-money-format') || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    if (/no_decimals/.test(format)) amount = Math.round(cents / 100).toString();
    if (/comma_separator/.test(format)) amount = amount.replace('.', ',');
    return format.replace(/\{\{\s*[^}]+\s*\}\}/, amount);
  }

  var cartDrawer = {
    root: null,
    init: function () {
      this.root = document.getElementById('cart-drawer-root');
      if (!this.root) return;
      this.bind();
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener) {
          e.preventDefault();
          cartDrawer.open();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && cartDrawer.root.classList.contains('open')) {
          cartDrawer.close();
        }
      });
    },
    bind: function () {
      var self = this;
      this.root.querySelectorAll('[data-cart-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      this.root.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('[data-line]');
          var input = line.querySelector('input[data-qty-input]');
          var next = parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-change'), 10);
          self.changeLine(line.getAttribute('data-line'), Math.max(0, next));
        });
      });
      this.root.querySelectorAll('input[data-qty-input]').forEach(function (input) {
        input.addEventListener('change', function () {
          var line = input.closest('[data-line]');
          self.changeLine(line.getAttribute('data-line'), Math.max(0, parseInt(input.value, 10) || 0));
        });
      });
      this.root.querySelectorAll('[data-line-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('[data-line]');
          self.changeLine(line.getAttribute('data-line'), 0);
        });
      });
    },
    open: function () {
      this.root.classList.add('open');
      document.body.style.overflow = 'hidden';
      var closeBtn = this.root.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.focus();
    },
    close: function () {
      this.root.classList.remove('open');
      document.body.style.overflow = '';
    },
    refresh: function (openAfter) {
      var self = this;
      return fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('cart-drawer-root');
          if (!fresh) return;
          var wasOpen = self.root.classList.contains('open');
          fresh.classList.toggle('open', wasOpen || !!openAfter);
          self.root.replaceWith(fresh);
          self.root = fresh;
          self.bind();
          var count = fresh.getAttribute('data-item-count') || '0';
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = count;
            el.setAttribute('data-empty', count === '0' ? 'true' : 'false');
          });
          if (openAfter) document.body.style.overflow = 'hidden';
        });
    },
    changeLine: function (line, quantity) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
      }).then(function () { self.refresh(false); });
    }
  };

  function initProductForms() {
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-to-cart]');
        var label = btn ? btn.querySelector('[data-add-label]') : null;
        var original = label ? label.textContent : '';
        if (btn) btn.disabled = true;
        if (label) label.textContent = 'adding';
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () {
            return cartDrawer.refresh(true);
          })
          .catch(function (err) {
            var msg = form.querySelector('[data-form-error]');
            if (msg) {
              msg.textContent = (err && err.description) || 'could not add to cart';
              msg.hidden = false;
            }
          })
          .finally(function () {
            if (btn) btn.disabled = false;
            if (label) label.textContent = original;
          });
      });
    });
  }

  function initVariantPickers() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var jsonEl = picker.querySelector('script[data-variants-json]');
      var form = document.querySelector('form[data-product-form]');
      if (!jsonEl || !form) return;
      var variants = JSON.parse(jsonEl.textContent);
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var compareEl = document.querySelector('[data-product-compare]');
      var btn = form.querySelector('[data-add-to-cart]');
      var label = btn ? btn.querySelector('[data-add-label]') : null;

      picker.addEventListener('change', function () {
        var selected = [];
        picker.querySelectorAll('.option-group').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          if (checked) selected.push(checked.value);
        });
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        if (!match) return;
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = money(match.compare_at_price);
            compareEl.hidden = false;
            if (priceEl) priceEl.classList.add('price--sale');
          } else {
            compareEl.hidden = true;
            if (priceEl) priceEl.classList.remove('price--sale');
          }
        }
        if (btn && label) {
          btn.disabled = !match.available;
          label.textContent = match.available ? 'add to cart' : 'sold out';
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  function initQtySteppers() {
    document.querySelectorAll('[data-qty-standalone]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10);
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initCartPage() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;
    page.querySelectorAll('[data-line]').forEach(function (row) {
      var line = row.getAttribute('data-line');
      var input = row.querySelector('input[data-qty-input]');
      row.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-change'), 10));
          updateCartPage(line, next);
        });
      });
      if (input) {
        input.addEventListener('change', function () {
          updateCartPage(line, Math.max(0, parseInt(input.value, 10) || 0));
        });
      }
      var remove = row.querySelector('[data-line-remove]');
      if (remove) {
        remove.addEventListener('click', function () { updateCartPage(line, 0); });
      }
    });
    function updateCartPage(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
      }).then(function () { window.location.reload(); });
    }
  }

  function initSortSelect() {
    document.querySelectorAll('select[data-sort-by]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form[data-filter-form]');
        if (form) {
          form.submit();
          return;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  function initFilters() {
    document.querySelectorAll('form[data-filter-form] .filter input[type="checkbox"]').forEach(function (box) {
      box.addEventListener('change', function () {
        box.closest('form').submit();
      });
    });
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.filter[open]').forEach(function (panel) {
        if (!panel.contains(e.target)) panel.removeAttribute('open');
      });
    });
  }

  function initAgeGate() {
    var gate = document.getElementById('age-gate');
    if (!gate) return;
    var KEY = 'wine41:of-age';
    var stored = null;
    try { stored = window.localStorage.getItem(KEY); } catch (e) {}
    if (stored) return;
    gate.classList.add('open');
    document.body.style.overflow = 'hidden';
    var yes = gate.querySelector('[data-age-yes]');
    var no = gate.querySelector('[data-age-no]');
    if (yes) {
      yes.addEventListener('click', function () {
        try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
        gate.classList.remove('open');
        document.body.style.overflow = '';
      });
      yes.focus();
    }
    if (no) {
      no.addEventListener('click', function () {
        window.location.href = 'https://www.google.com';
      });
    }
  }

  function initHeroVideo() {
    var video = document.querySelector('.hero video');
    if (!video) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
  }

  function initGalleryLightbox() {
    var items = [].slice.call(document.querySelectorAll('[data-gallery-item]'));
    if (!items.length) return;

    var lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button class="lightbox__close" type="button" aria-label="Close">&times;</button>' +
      '<button class="lightbox__nav lightbox__nav--prev" type="button" aria-label="Previous">&#8249;</button>' +
      '<img class="lightbox__img" alt="">' +
      '<button class="lightbox__nav lightbox__nav--next" type="button" aria-label="Next">&#8250;</button>' +
      '<div class="lightbox__cap"></div>';
    document.body.appendChild(lb);

    var img = lb.querySelector('.lightbox__img');
    var cap = lb.querySelector('.lightbox__cap');
    var idx = 0;

    function show(i) {
      idx = (i + items.length) % items.length;
      var el = items[idx];
      img.src = el.getAttribute('data-full');
      var c = el.getAttribute('data-caption') || '';
      img.alt = c || 'Wine41 photo';
      cap.textContent = c;
      cap.style.display = c ? 'block' : 'none';
    }
    function open(i) {
      show(i);
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      lb.classList.remove('open');
      document.body.style.overflow = '';
      img.src = '';
    }

    items.forEach(function (el, i) {
      el.addEventListener('click', function () { open(i); });
    });
    lb.querySelector('.lightbox__close').addEventListener('click', close);
    lb.querySelector('.lightbox__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    lb.querySelector('.lightbox__nav--next').addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  ready(function () {
    initHeroVideo();
    initGalleryLightbox();
    initHeader();
    initReveals();
    cartDrawer.init();
    initProductForms();
    initVariantPickers();
    initQtySteppers();
    initCartPage();
    initSortSelect();
    initFilters();
    initAgeGate();
  });
})();
